import { translations } from '@adornis/buchungsheld-db/translations/translation.js';

export const translationsMatching = {
  ...translations,
  field: {
    ...translations.field,
    faculty: ['Fachbereich Hochschule Fulda', 'Department Hochschule Fulda'],
    matches: ['Matches', 'Matches'],
    numMatches: ['Anzahl Matches', 'Number of Matches'],
    note: ['Notiz', 'Note'],
    mentor: ['Mentor', 'Mentor'],
    mentee: ['Mentee', 'Mentee'],
    comments: ['Verlauf/Kommentare', 'History/Comments'],
    text: ['Text', 'Text'],
    isAlert: ['Markiert', 'tagged'],
    department: ['Fachbereich', 'Department'],
    fachbereich: ['Fachbereich', 'Department'],
    nativeLanguage: ['Muttersprache', 'Native Language'],
    sorting: ['Sortierung festlegen', 'Set Sorting'],
    sortingHide: ['Sortierung einklappen', 'Collapse sorting'],
    hiddenFromMentees: ['Vor Mentees verborgen', 'Hidden from Mentees'],
  },
  enums: {
    ...translations.enums,
    mnnlich: ['männlich', 'male'],
    keineangabe: ['keine Angabe', 'prefer not to say'],
    gleichesgeschlecht: ['gleiches Geschlecht', 'same gender'],
    keineprferenz: ['keine Präferenz', 'no preference'],
    JA: ['Ja', 'Yes'],
    NEIN: ['Nein', 'No'],
  },

  timeframe: {
    ...translations.timeframe,

    noticeForClosedRegistration: ['Hinweis wenn die Anmeldung geschlossen ist', 'Notice for closed registration'],
    cleanupUserData: ['alle Daten im Semester löschen', `Delete all data in this semester`],
  },

  user: {
    note_exists: ['Notiz vorhanden', 'has note'],
  },

  mentor: {
    singular: ['Mentor', 'Mentor'],
    plural: ['Mentoren', 'Mentors'],
    all_termins: ['Alle Mentoren', 'all mentors'],
  },

  mentee: {
    singular: ['Mentee', 'Mentee'],
    plural: ['Mentees', 'Mentees'],
    all_termins: ['Alle Mentees', 'all mentees'],
  },
  buddy: {
    mentorSignupTitle: ['Anmeldeformular für begleitende Mentoren', 'Registration form for supporting mentors'],
    menteeSignupTitle: ['Anmeldeformular für internationale Mentees', 'Registration form for international Mentees'],
    allMentors: ['Alle Mentoren', 'All Mentors'],
    allMentees: ['Alle Mentees', 'All Mentees'],
    personalData: ['Persönliche Daten', 'Personal data'],
    additionalData: ['Zusätzliche Informationen', 'Additional information'],

    noTimeFrameChoosen: ['Kein Timeframe ausgewählt', 'No timeframe selected'],
    signupClosed: ['Anmeldung ist geschlossen', 'Signup is closed'],

    signup: ['Anmelden', 'Sign up'],
    successfullyRegistered: ['Erfolgreich angemeldet', 'Successfully signed up'],
    save: ['Speichern', 'Save'],
    yes: ['Ja', 'Yes'],
    no: ['Nein', 'No'],
    saved: ['Gespeichert', 'Saved'],

    'create-user': ['Nutzer erstellen', 'create user'],
    noUsersYet: ['Noch keine Nutzer vorhanden.', 'No users created yet.'],
    noMatchesYet: ['Noch keine Matches vorhanden.', 'No matches created yet.'],
    dragPersonHere: ['Person hierhin ziehen', 'Drag Person here'],
    createMatches: ['Matches erstellen', 'Create Matches'],
    createMatchesConfirm: [
      'Möchten Sie wirklich diese Matches erstellen?',
      'Do you really want to create these matches?',
    ],
    createMatchesSuccessful: ['# Matches wurden erfolgreich erstellt.', '# matches have been created successfully.'],

    removeMatch: ['Match auflösen', 'Dissolve match'],
    removeMatchConfirm: ['Möchten Sie wirklich dieses Match auflösen?', 'Do you really want to dissolve this match?'],
    removeMatchSuccessful: ['Match wurden erfolgreich aufgelöst.', 'Match has been dissolved successfully.'],

    export: ['Exportieren', 'Export'],
    exportAllMatches: ['Alle Matches exportieren', 'Export all Matches'],
    exportMenteeUser: ['Alle Mentees exportieren', 'Export all Mentees'],
    exportMentorUser: ['Alle Mentoren exportieren', 'Export all Mentors'],
    exportMatchedMenteeUser: ['Alle gematchten Mentees exportieren', 'Export all matched Mentees'],
    exportMatchedMentorUser: ['Alle gematchten Mentoren exportieren', 'Export all matched Mentors'],
    allFields: [
      'Alle Felder exportieren (wenn diese Checkbox nicht ausgewählt ist, werden nur die ausgewählten Felder exportiert)',
      'Export all fields (if this checkbox is not selected, only the selected fields will be exported)',
    ],
    exportCurriculumVitae: ['Lebensläufe exportieren', 'Export resumes'],
    exportSuccess: ['Export erfolgreich, download wird gestartet...', 'Export successful, download is starting...'],
    exportFailed: ['Export leider fehlgeschlafen', 'Export unfortunately failed'],
    showAll: ['Alles anzeigen', 'Show everything'],
    history: ['Verlauf', 'History'],
    comments: ['Kommentare', 'Comments'],

    note: ['Notiz', 'Note'],
    saveNote: ['Notiz speichern', 'Save note'],

    sendCircularMail: {
      mentors: ['Rundmail an Mentoren', 'Circular Mail to Mentors'],
      all: ['Rundmail an Alle', 'Circular Mail to Everyone'],
      mentees: ['Rundmail an Mentees', 'Circular Mail to Mentees'],
    },
    matchActions: {
      sendReminderMail: ['Erinnerungsmail schicken', 'Send reminder mails'],
      sendFreeformMail: ['Freitext E-Mail schicken', 'Send freeform mail'],
    },
  },
  route: {
    'signup-mentor': ['Anmeldung Mentor', 'Signup Mentor'],
    'signup-mentee': ['Anmeldung Mentee', 'Signup Mentee'],
    matching: ['Matching', 'Matching'],
    matches: ['Matches', 'Matches'],
    'fields-mentor': ['Felder für Mentoren', 'Fields for Mentors'],
    'fields-mentee': ['Felder für Mentees', 'Fields for Mentees'],
    timeframes: ['Semesterverwaltung', 'Semester Management'],
    'admin-users': ['Admin-Nutzer-Verwaltung', 'Admin User Management'],
    mails: ['E-Mail-Konfiguration', 'Email Configuration'],
    'translation-editor': ['Übersetzungen', 'Translations'],
    export: ['Export', 'Export'],
    'legal-pages': ['Rechtliche Seiten', 'Legal Pages'],
  },
} as const;

export type TranslationDictionaryBuddy = typeof translationsMatching;
